import React, { Component } from 'react'
import { Menu,Modal,message } from 'antd'
import { Link, withRouter } from 'react-router-dom';
import './queryLeft.scss'
import axios from 'axios';
import { requestErrorLog } from "@/common/util";

class QueryLeft extends Component {
  state = {
    pathName: '',
    isBI: this.props.location.search.indexOf('isQHDBI') > -1 ? true : false,
    routerData: this.props.location.pathname.split('/')[1],
    iframeVisible: false,
  }
  componentDidMount() {
    this.setState({
      pathName: this.props.location.search.split('=')[1],
      HOSPITAL_CODE:JSON.parse(localStorage.userInfo).HOSPITAL_CODE,
      iframeHeight:window.document.body.clientHeight-5
    })
  }
  jumpUrl = (type) => {
    if (type === "GraphStatisticsBI") {
      this.props.history.push('/GraphStatisticsBI?applyCode='+this.props.applyCode+'&consultationCode='+this.props.consultationCode+'&isQHDBI')
    } else if (type === "CustomSearchBI") {
      this.props.history.push('/CustomSearchBI?applyCode='+this.props.applyCode+'&consultationCode='+this.props.consultationCode+'&isQHDBI')
    } else if (type === "StatisticsTableBI") {
      this.props.history.push('/StatisticsTableBI?applyCode='+this.props.applyCode+'&consultationCode='+this.props.consultationCode+'&isQHDBI')
    } else {
      this.props.history.push('/siderPage?key=' + type)
    }
    window.location.reload()
  }
  jumpSettlement = () => {
    axios({
      method: 'post',
      url: window.g.huakangloginURL,
      data: {
        hospitalId:JSON.parse(localStorage.userInfo).HOSPITAL_CODE
      }
    }).then((res)=>{
      if(res.data.success){
        this.setState({
          iframeVisible: this.state.iframeVisible ? false : true,
          tokenData:res.data.data
        })
      }else{
        message.error('未找到匹配权限，请联系供应商')
        // this.setState({
        //   iframeVisible: this.state.iframeVisible ? false : true,
        // })
        return
      }
    })
  }
  closeSettlementModal = () => {
    //调用华康接口，清除华康登录token
    let params = {
      method: 'post',
      url: window.g.huakangLogoutURL,
      data: {
        token: "123456",
      }
    }
    axios(params).then(() => {//甭管成没成功关掉结算页面不影响本系统功能
      this.setState({
        iframeVisible: false
      })
    }).catch(err => {
      requestErrorLog('', '调用华康退出接口报错:' + JSON.stringify(params), 0, false)
      this.setState({
        iframeVisible: false
      })
    });
  }
  render() {
    const { isBI, routerData,iframeVisible } = this.state
    return (
      <div className="pageLeft" style={{ height: '100%' }}>
        <Menu
          // defaultSelectedKeys={}
          mode="inline"
          className="pageSlderWrap"
        >
          <Menu.Item key="1" className={this.state.pathName === '16' ? 'active' : routerData === 'GraphStatisticsBI' ? 'active' : ''}>
            <Link to={isBI ? '/GraphStatisticsBI?applyCode='+this.props.applyCode+'&consultationCode='+this.props.consultationCode+'&isQHDBI' : "/siderPage?key=16"} onClick={this.jumpUrl.bind(this, isBI ? 'GraphStatisticsBI' : 16)}>
              <img src={require("../../assets/image/graphStatistics.png").default} alt="" />
              <p>统计图形</p>
            </Link>
          </Menu.Item>
          <Menu.Item key="2" className={this.state.pathName === '17' ? 'active' : routerData === 'CustomSearchBI' ? 'active' : ''}>
            <Link to={isBI ? '/CustomSearchBI?applyCode='+this.props.applyCode+'&consultationCode='+this.props.consultationCode+'&isQHDBI' : "/siderPage?key=17"} onClick={this.jumpUrl.bind(this, isBI ? 'CustomSearchBI' : 17)}>
              <img src={require("../../assets/image/customSearch.png").default} alt="" />
              <p>自定义查询</p>
            </Link>
          </Menu.Item>
          <Menu.Item key="3" className={this.state.pathName === '18' ? 'active' : routerData === 'StatisticsTableBI' ? 'active' : ''}>
            <Link to={isBI ? '/StatisticsTableBI?applyCode='+this.props.applyCode+'&consultationCode='+this.props.consultationCode+'&isQHDBI' : "/siderPage?key=18"} onClick={this.jumpUrl.bind(this, isBI ? 'StatisticsTableBI' : 18)}>
              <img src={require("../../assets/image/statisticsTable.png").default} alt="" />
              <p>统计报表</p>
            </Link>
          </Menu.Item>
          {
            window.g.isSettlement ? <Menu.Item key="4">
              <a href='#' onClick={this.jumpSettlement}>
                <img src={require("../../assets/image/money.png").default} alt="" />
                <p>结算</p>
              </a>
            </Menu.Item> : null
          }
          <Modal
            width="100%"
            visible={iframeVisible}
            onCancel={this.closeSettlementModal}
            footer={null}
            className='iframeModal'
            >
            <div style={{ width: '100%', height:this.state.iframeHeight}}>
              <iframe src={window.g.huakangHTMLURL+this.state.tokenData} width="100%" height={this.state.iframeHeight} frameBorder="0" scrolling="false" title='huakang'>
              </iframe>
            </div>
          </Modal>
        </Menu>
      </div>
    )
  }
}
export default withRouter(QueryLeft)